import React from 'react';

import { GENDER_CHART } from 'constants/charts';
import ChartReport from 'components/charts/Chart';

const ParticipantsOvertimeReport = ({ questionId, startDate, endDate }) => {
  return (
    <div className="p-3 d-flex" style={{ overflowX: 'scroll' }}>
      <ChartReport
        titleText="How many times were the answers chosen by participants?"
        category="answers_over_time"
        chartType="line"
        showGrids
        colors={GENDER_CHART}
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
        height={315}
      />
      <ChartReport
        titleText="How many participants took your survey over time?"
        category="participants_over_time"
        chartType="line"
        showGrids
        legendConfig={{ enabled: false }}
        colors={GENDER_CHART}
        questionId={questionId}
        startDate={startDate}
        endDate={endDate}
        height={315}
      />
    </div>
  );
};

export default ParticipantsOvertimeReport;



// WEBPACK FOOTER //
// ./src/components/advancedReport/participantsOvertimeCharts.js